import React from "react";

type Props = {
	position: number;
	onSelectPosition: (position: number) => void;
} & React.HTMLAttributes<HTMLDivElement>;

const IMImageSliderProgress = ({ ...rest }: Props) => {
	return <div {...rest}>{/* Content */}</div>;
};

export default IMImageSliderProgress;
